var map = {
	"./askgov/default/AskGovDetail.vue": "5dac",
	"./askgov/dianjiang/AskGovDetail.vue": "3271",
	"./columndetail/default/ColumnDetail.vue": "9126",
	"./columndetail/nanan/ColumnDetail.vue": "fa99",
	"./details/default/NewsReleaseDetails.vue": "3154",
	"./details/kaizhou/NewsReleaseDetails.vue": "a4ef",
	"./details/test/NewsReleaseDetails.vue": "1d53",
	"./graphic/banan/GraphicPage.vue": "b16a",
	"./graphic/default/GraphicPage.vue": "c92e",
	"./graphic/dianjiang/GraphicPage.vue": "70ad",
	"./graphic/fengjie/GraphicPage.vue": "5f72",
	"./graphic/fuling/GraphicPage.vue": "a33f",
	"./graphic/jiangjin/GraphicPage.vue": "7448",
	"./graphic/jiulongpo/GraphicPage.vue": "22b2",
	"./graphic/lianmeng/GraphicPage.vue": "530b",
	"./graphic/newchongqing/GraphicPage.vue": "eb9f",
	"./graphic/wanzhou/GraphicJyh.vue": "7135",
	"./graphic/wanzhou/GraphicPage.vue": "ffc2",
	"./graphic/wanzhou/GraphicPinghu.vue": "cc9f",
	"./historian/default/historianPage.vue": "15c4",
	"./house/default/BegDetail.vue": "6928",
	"./house/default/HouseDetail.vue": "0f32",
	"./jobs/default/JobDetail.vue": "fc39",
	"./jobs/tongnan/JobDetail.vue": "7a0b",
	"./live/default/NewsRelease.vue": "8189",
	"./live/default/NewsRelease1.vue": "c1a0",
	"./live/kaizhou/NewsRelease.vue": "736b",
	"./live/kaizhou/NewsRelease1.vue": "33ee",
	"./live/test/NewsRelease.vue": "e6ea",
	"./multiple/default/NewsMultiple.vue": "bdf9",
	"./multiple/fengjie/NewsMultiple.vue": "78fc",
	"./multiple/jiangjin/NewsMultiple.vue": "549e",
	"./multiple/jiulongpo/NewsMultiple.vue": "14e5",
	"./multiple/newchongqing/NewsMultiple.vue": "ce6b",
	"./multiple/test/NewsMultiple.vue": "6e62",
	"./multiple/wanzhou/NewsMultiple.vue": "73f3",
	"./multiple/wanzhou/NewsMultipleJyh.vue": "8feb",
	"./multiple/wanzhou/NewsMultiplePinghu.vue": "8a2c",
	"./newslist/nanan/NewsList.vue": "265d",
	"./newspage/default/NewsPage.vue": "f6b3",
	"./newspage/fengdu/NewsPage.vue": "510f",
	"./newspage/tongnan/NewsPage.vue": "525d",
	"./screen/default/ScreenVideo.vue": "4bfa",
	"./screen/dianjiang/ScreenVideo.vue": "92cf",
	"./screen/jiangjin/ScreenVideo.vue": "1e83",
	"./screen/jiulongpo/ScreenVideo.vue": "e95ad",
	"./screen/kaizhou/ScreenVideo.vue": "95cc",
	"./special/banan/SpecialPage.vue": "8d1e",
	"./special/default/SpecialList.vue": "08e1",
	"./special/default/SpecialPage.vue": "fc29",
	"./special/default/SpecialTopicPage.vue": "7e76",
	"./special/fengjie/SpecialPage.vue": "a913",
	"./special/fuling/SpecialPage.vue": "a214",
	"./special/jiangjin/SpecialList.vue": "a8d9",
	"./special/jiangjin/SpecialPage.vue": "2db6",
	"./special/jiangjin/SpecialTopicPage.vue": "d7ce",
	"./special/jiulongpo/SpecialPage.vue": "c520",
	"./special/kaizhou/MediaTopicPage.vue": "ea89",
	"./special/nanan/SpecialPage.vue": "9bdc",
	"./special/test/SpecialPage.vue": "fb51",
	"./special/wanzhou/SpecialPage.vue": "3371",
	"./topic/default/TopicDetail.vue": "57a3",
	"./topic/default/topic.vue": "6cb3",
	"./video/banan/VerticalVideo.vue": "f3fa",
	"./video/banan/VideoPage.vue": "bbc7",
	"./video/beibei/VideoPage.vue": "73be",
	"./video/default/VerticalVideo.vue": "ff7d",
	"./video/default/VideoPage.vue": "dedc",
	"./video/fengjie/VideoPage.vue": "2bc9",
	"./video/fuling/VideoPage.vue": "7249",
	"./video/jiangbei/VideoPage.vue": "c4ee",
	"./video/jiangjin/VideoPage.vue": "5975",
	"./video/jiulongpo/VideoPage.vue": "b1dc",
	"./video/newchongqing/VerticalVideo.vue": "a15f",
	"./video/newchongqing/VideoPage.vue": "2014",
	"./video/qijiang/VideoPage.vue": "554e",
	"./video/tongliang/VideoPage.vue": "8e21",
	"./video/wanzhou/VerticalVideo.vue": "2e1e",
	"./video/wanzhou/VideoJyh.vue": "d2ac",
	"./video/wanzhou/VideoPage.vue": "fdbb",
	"./video/wanzhou/VideoPinghu.vue": "d216"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5009";